import { createReducer, on } from '@ngrx/store';
import { AnnouncementArchiveEntitiesState } from './announcement-archive-entities.state';
import { announcementArchiveEntitiesStateInitial } from './announcement-archive-entities.state.initial';
import { AnnouncementArchiveEntitiesActions } from './announcement-archive-entities.actions';

/**
 * Reducer für die Archiv-Seite.
 *
 * Kein EntityAdapter — flache paginierte Liste.
 */
export const announcementArchiveEntitiesReducers = createReducer(
  announcementArchiveEntitiesStateInitial,

  on(
    AnnouncementArchiveEntitiesActions.loadPage,
    (state): AnnouncementArchiveEntitiesState => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),

  on(
    AnnouncementArchiveEntitiesActions.loadPageSuccess,
    (state, { announcements, totalElements, page }): AnnouncementArchiveEntitiesState => ({
      ...state,
      announcements,
      totalElements,
      currentPage: page,
      isLoading: false,
      isLoaded: true,
      error: null,
    }),
  ),

  on(
    AnnouncementArchiveEntitiesActions.loadPageFailure,
    (state, { error }): AnnouncementArchiveEntitiesState => ({
      ...state,
      isLoading: false,
      isLoaded: true,
      error,
    }),
  ),

  on(
    AnnouncementArchiveEntitiesActions.loadImageSuccess,
    (state, { imageId, blobUrl }): AnnouncementArchiveEntitiesState => ({
      ...state,
      imageUrls: {
        ...state.imageUrls,
        [imageId]: blobUrl,
      },
    }),
  ),

  // INFO: imageUrls werden beim Reset bewahrt, damit bereits geladene Bilder
  // beim erneuten Öffnen des Archivs nicht erneut vom Backend angefragt werden.
  on(
    AnnouncementArchiveEntitiesActions.reset,
    (state): AnnouncementArchiveEntitiesState => ({
      ...announcementArchiveEntitiesStateInitial,
      imageUrls: state.imageUrls,
    }),
  ),
);
